export default {
  en: {
    progress: '{{used}} of {{total}} used',
  },
  ru: {
    progress: 'Использовано {{used}} из {{total}}',
  },
};
